import React from 'react'
import { Icon } from '../Icon'
import { colors } from '@lmc/common/constants'
import { IconName } from '../Icon/Icon'

// This component is intended as an alternative to the
// ListItem, and is used in the various dashboards
// in the product. See the HomeDashboard in Groups/Home
// for an example of it alongside a ListItem.
interface DashboardListItemProps {
  count?: string | number
  iconFill?: string
  iconMarginRight?: number
  iconMarginTop?: number
  iconName?: IconName
  iconSize?: number
  iconViewBox?: string
  text?: string
  styles?: any
}
const DashboardListItem: React.FC<DashboardListItemProps> = ({
  iconName,
  iconFill,
  iconSize,
  iconViewBox,
  iconMarginTop,
  iconMarginRight,
  text,
  count,
  styles,
}) => {
  const isFaded = count === '0' || count === 0

  if (count === 'null' || count === 'undefined') {
    return null
  }

  return (
    <div>
      {/* If the count value is zero, the icon, number
            and text will be greyed out */}
      <div style={styles?.container ?? defaultStyles.container}>
        <Icon
          name={iconName}
          fill={isFaded ? colors.darkgrey : iconFill}
          size={iconSize}
          viewBox={iconViewBox}
          style={{
            marginTop: iconMarginTop,
            marginRight: iconMarginRight || 10,
          }}
        />
        <span
          id={text}
          style={
            isFaded
              ? { ...defaultStyles.textGrey, marginRight: 5 }
              : defaultStyles.count
          }
        >
          {count}
        </span>
        <span style={isFaded ? defaultStyles.textGrey : defaultStyles.text}>
          {text}
        </span>
      </div>
    </div>
  )
}

const defaultStyles = {
  container: {
    alignItems: 'center',
    borderRadius: 1000,
    display: 'inline-flex',
    margin: '0px 8px 10px 0px',
    padding: '0px 0px 0px 0px',
  },
  count: {
    fontSize: 14,
    fontWeight: 'bold',
    marginRight: 5,
  },
  icon: {
    marginRight: 10,
  },
  listItem: {
    verticalAlign: 'middle',
  },
  text: {
    fontSize: 14,
  },
  textGrey: {
    fontSize: 14,
    color: colors.darkgrey,
  },
}

export default DashboardListItem
